export default "__VITE_ASSET__DNtp$_p6__"